import { useState } from 'react';
import { useRichRelevance } from '@noths/polaris-client-react-hooks';
import getConfig from 'next/config';

import { NextConfig } from 'src/types/NextConfig';
import { ProductPlacement } from 'src/types/RichRelevance';

const { publicRuntimeConfig } = getConfig() as NextConfig;

export interface usePageReichRelevanceDataOptions {
  sessionId?: string;
  hasDisabledCookies: boolean;
  configurePlacement: () => boolean;
}

export const usePageRichRelevanceData = ({
  sessionId,
  hasDisabledCookies,
  configurePlacement,
}: usePageReichRelevanceDataOptions) => {
  const [richRelevanceData, setRichRelevanceData] = useState<ProductPlacement | undefined>();

  useRichRelevance(
    {
      API_KEY: publicRuntimeConfig.RICH_RELEVANCE_API_KEY,
      endpoint: publicRuntimeConfig.RICH_RELEVANCE_URL,
      sessionId,
      hasDisabledCookies,
    },
    async (fetchPlacement, clearPlacement) => {
      if (configurePlacement()) {
        await fetchPlacement();

        /* istanbul ignore next */
        const placement = window.RR?.data?.JSON?.placements?.[0];

        if (placement) {
          setRichRelevanceData(placement);
        }

        clearPlacement();
      }
    },
  );

  return richRelevanceData;
};
